import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=7827f3cc&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=ts"
export * from "./BottomBar.vue?vue&type=script&lang=ts"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=7827f3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827f3cc",
  null
  
)

export default component.exports